import script from "./app-group-form.vue?vue&type=script&setup=true&lang=js"
export * from "./app-group-form.vue?vue&type=script&setup=true&lang=js"

import "./app-group-form.vue?vue&type=style&index=0&id=7e05e880&lang=css"

const __exports__ = script;

export default __exports__